export const typographyConfig = {
  fontSize: 12,
  h1: {
    fontSize: 40,
    fontWeight: 700,
  },
  h2: {
    fontSize: 32,
    fontWeight: 700,
  },
  h3: {
    fontSize: 24,
    fontWeight: 700,
  },
  h4: {
    fontSize: 20,
    fontWeight: 700,
  },
  h5: {
    fontSize: 14,
    fontWeight: 700,
  },
  h6: {
    fontSize: 10,
  },
  sm: {
    fontSize: 11,
  },
  xs: {
    fontSize: 10,
  },
};
